


























































































import { Component } from 'vue-property-decorator';

import uuidv4 from '@/utils/uuidv4';
import { isSafari } from '@/utils/is-safari';
import eventBus from '@/utils/eventBus';

import { BusinessOnboardingYourDigitalCoinsForm } from '@/models/business-onboarding';

import RotateIcon from '@/components/icons/RotateIcon.vue';
import CoinAnatomy from '@/components/icons/CoinAnatomy.vue';
import CoinAnatomySafari from '@/components/icons/CoinAnatomySafari.vue';
import CoinCustomizationForm from '@/componentsV2/templates/CoinCustomizationForm/CoinCustomizationForm.vue';
import { colorDefaultData } from '@/componentsV2/molecules/ColorPicker/colorsDictionary';

import YourDigitalCoinBase from '@/views/BusinessOnboarding/online/Steps/YourDigitalCoinBase.vue';

import { FilledButton } from '@/components/molecules';
import { handleCompleteTask } from '@/utils/start-guide';
import { EStartGuideTaskSlug } from '@/models/start-guide';
import { ReserveCoinInformations } from '@/models/coin-setup';
import recaptchaRoutesKeys from '@/constants/recaptchaRoutesKeys';
import flagKeys from '@/constants/flagKeys';
import Page from '@/componentsV2/molecules/Page/Page.vue';

@Component({
  components: {
    CoinAnatomy,
    CoinAnatomySafari,
    CoinCustomizationForm,
    RotateIcon,
    FilledButton,
    Page
  }
})
export default class Coin2dEdit extends YourDigitalCoinBase {
  initialCoin2dFormData: BusinessOnboardingYourDigitalCoinsForm = this
    .defaultValuesCoin2dForm;
  coin2dFormData: BusinessOnboardingYourDigitalCoinsForm = this
    .defaultValuesCoin2dForm;

  isEqualFormData = true;
  coinSelectIds = {
    front: 'coin-mirror-svg-element-edit-front',
    back: 'coin-mirror-svg-element-edit-back'
  };
  shouldAddBusinessId = true;

  mounted() {
    this.$showMediumBackgroundLocker();
    Object.assign(this.initialCoin2dFormData, this.coin2dFormData);
  }

  beforeDestroy() {
    this.$hideMediumBackgroundLocker();
  }

  get businessUUID() {
    return uuidv4();
  }

  get businessInfo() {
    return this.$store.getters['business/getBusinessInfo'].business;
  }

  get componentToRender() {
    return isSafari() ? 'CoinAnatomySafari' : 'CoinAnatomy';
  }

  get haveCoin2D() {
    return (
      this.businessInfo.coinSetup &&
      this.businessInfo.coinSetup.logo2d &&
      this.businessInfo.coinSetup.logo2d.publicPath
    );
  }

  get defaultValuesCoin2dForm() {
    const defaultObject: BusinessOnboardingYourDigitalCoinsForm = {
      coinShowFront: true,
      coinName: this.haveCoin2D
        ? this.businessInfo.coinSetup.coinName.replace('$', '')
        : '',
      isLoadingImg: false,
      color: this.haveCoin2D
        ? `#${this.businessInfo.coinSetup.color}`
        : colorDefaultData.colorHex,
      colorKey: this.haveCoin2D
        ? this.businessInfo.coinSetup.colorLabel
        : colorDefaultData.colorKey,
      image: {
        imageName: this.haveCoin2D
          ? `${this.businessInfo.coinSetup.coinName}_logo`
          : '',
        imageUrl: this.coinImage
      }
    };
    return defaultObject;
  }

  get coinImage() {
    const hasDefaultLogo =
      this.businessInfo.coinSetup && this.businessInfo.coinSetup.hasDefaultLogo;

    if (this.haveCoin2D && !hasDefaultLogo) {
      return this.businessInfo.coinSetup.logo2d.publicPath.original;
    }

    if (this.businessInfo.logo && !hasDefaultLogo) {
      return this.businessInfo.logo.publicPath.large;
    }

    return null;
  }

  get tPrefixCoin() {
    return 'coinLoyaltySettings.coin2dEdit';
  }

  onSubmit() {
    eventBus.$emit('submitCoinUpdates');
  }

  async handleReserveCoinInformations(
    payload: ReserveCoinInformations,
    formData: BusinessOnboardingYourDigitalCoinsForm,
    images?: Record<string, any>
  ) {
    const recaptchaCoinSetupReserve = await this.getRecaptcha(
      recaptchaRoutesKeys.businessCoinSetupReserve,
      flagKeys.businessCoinSetupReserveCaptcha
    );

    const {
      status,
      data = {}
    } = await this.coinSetupService.reserveCoinInformations(
      payload,
      recaptchaCoinSetupReserve
    );

    if (status === 400) {
      this.$notification(
        String(this.$t(`${this.tPrefix}.errorReserveInfos`)),
        'error'
      );

      return;
    }

    this.nameUnavaiable = false;

    const params = this.$route.params;

    handleCompleteTask(EStartGuideTaskSlug.CUSTOMIZE_COIN);

    let imageFrontData;

    if (!this.coinImageIsOptional && images && images.frontImageResponse) {
      imageFrontData = images.frontImageResponse.data;
    } else if (data.coinFront2d) {
      imageFrontData = {
        publicPath: data.coinFront2d
      };
    }

    this.$store.dispatch('business/SET_BUSINESS_INFO', {
      ...this.businessInfo,
      coinSetup: {
        ...this.businessInfo.coinSetup,
        coinName: `$${this.coin2dFormData.coinName}`,
        hasDefaultLogo: !!images && !images.frontImageResponse,
        color: this.coin2dFormData.color.replace('#', ''),
        ...(imageFrontData && {
          coinFront2d: imageFrontData
        }),
        ...(images &&
          images.backImageResponse && {
            coinBack2d: images.backImageResponse.data
          }),
        ...(images &&
          images.originalLogoImageResponse && {
            logo2d: images.originalLogoImageResponse.data
          })
      },
      ...(imageFrontData && {
        logo: imageFrontData
      })
    });

    this.nameUnavaiable = false;
    eventBus.$emit('reloadBusinessMenuDropdown');
    this.$notification(
      String(this.$t(`${this.tPrefixCoin}.successNotification`)),
      'success'
    );
    Object.assign(this.initialCoin2dFormData, formData);

    if (params.taskSlug) {
      this.$router.push('/home');
    }
  }

  triggerUploadImageComponent() {
    if (!this.coin2dFormData.coinShowFront) {
      return;
    }

    const elementOfTrigger =
      this.coin2dFormData.image && this.coin2dFormData.image.imageUrl
        ? document.getElementById('image-upload-block-edit')
        : document.getElementById('image-upload-block');

    if (elementOfTrigger) {
      elementOfTrigger.click();
    }
  }
}
